import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type InitiativeModel from './initiative';

export type BonCalculation = {
  type?: string;
  weeks?: number;
  people?: number;
  confidence_value?: number;
  person_weeks?: number;
  role_id?: string;
  team_id?: string;
  [key: string]: unknown;
};

export default class BonModel extends Model {
  declare [Type]: 'bon';
  @belongsTo('initiative', {
    async: true,
    inverse: 'bon',
  })
  declare initiative: AsyncBelongsTo<InitiativeModel>;
  @attr declare notes: unknown;
  @attr declare value: number;
  @attr declare investments: { calculations: BonCalculation[] } | undefined;
  @attr declare returns: unknown;
  @attr declare text_delta: unknown;

  get personWeekInvestments() {
    if (this.investments == undefined) return [];

    return this.investments.calculations.filter((c) => {
      return (
        (c.type == 'investment' ||
          c.type == 'person-weeks' ||
          c.type == 'person-weeks-role') &&
        c.weeks != undefined &&
        c.people != undefined &&
        c.confidence_value != undefined
      );
    });
  }
}
